import React, { Component } from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';

import request from 'request-promise';
import moment from 'moment';

import Config from '../../conf';

import {CustomTimePicker as styles} from './elements.css';

class CustomTimePicker extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
      endTimes: [],

      startTime: null,
      endTime: null,
      isLoading: true,

      errorDialog: false
    };

    this.setDialogOpen = this.setDialogOpen.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.lockInTimes = this.lockInTimes.bind(this);

    this.buildTimeObject = this.buildTimeObject.bind(this);

    this.format = this.format.bind(this);
  }

  setDialogOpen(open) {
    if (!moment(this.props.details.date).isValid()) {
      this.setState({
        errorDialog: true
      });
      return;
    }

    let startTime = null;
    let endTime = null;

    // read existing startTime and endTime, if any
    if (this.props.details.time && this.props.details.time.indexOf(' to ') !== -1) {
      const splitted = this.props.details.time.split(' to ');
      startTime = splitted[0];
      endTime = splitted[1];
    }

    const options = {
      uri: Config.BACKEND_API_URL + 'washerhome/available-slots/' + moment(this.props.details.date).toISOString(),
      qs: {
        postcode: 2010, // this is hardcoded as whitelabels should be able to book anyw
        package: this.props.details.washType
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      json: true 
    };

    return request(options).then((response) => {
      const day = (moment(this.props.details.date).format('dddd')).toLowerCase();
      const data = response.result.b2c[day].avail;
    
      if (data.length === 0) data.push('No Times available for this day');
    
      this.setState({
        dialogOpen: open,
        startTimes: data,
        startTime: startTime,
        endTime: endTime,
        isLoading: false
      });
    }).catch((err) => {
      console.log('Failed to get Booking slots',err);
    });
  }


  buildTimeObject(time) {

    const hour = Math.floor(time);
    const minutes = (time - hour) * 60;

    return {
      hours: hour,
      mins: minutes 
    }
  }

  format(time) {
    const momentFormat = 'h:mm a';
    
    const startHour = Math.floor(time);
    const startMinutes = (time - startHour) * 60;

    const endTime = time + this.props.details.washDetails[(this.props.details.washType).toUpperCase()].duration;
    const endHour = Math.floor(endTime);
    const endMinutes = (endTime - endHour) * 60;

    const startFomatted = moment().hours(startHour).minutes(startMinutes).format(momentFormat);
    const endFormatted = moment().hours(endHour).minutes(endMinutes).format(momentFormat);

    return startFomatted + ' - ' + endFormatted; 
  }

  handleStartTimeChange(evt, idx, val) {
    this.setState({
      startTime: val,
      endTime: val + this.props.details.washDetails[(this.props.details.washType).toUpperCase()].duration,
    });
  }

  handleEndTimeChange(evt, idx, val) {
    this.setState({
      endTime: val
    });
  }

  // sets the time span in the parent component and closes the modal
  lockInTimes() {
    this.props.fieldChanged('time', this.format(this.state.startTime));
    this.props.fieldChanged('startTime', this.buildTimeObject(this.state.startTime));
    this.props.fieldChanged('endTime', this.buildTimeObject(this.state.endTime));
    this.setDialogOpen(false);
  }

  render() {
    const actions = [
      <RaisedButton
        label="Cancel"
        primary={false}
        onTouchTap={() => this.setDialogOpen(false)}
        style={styles.dialogButton}
      />,
      <RaisedButton
        label="Ok"
        primary={true}
        onTouchTap={this.lockInTimes}
        disabled={!this.state.startTime || !this.state.endTime}
        style={styles.dialogButton}
      />
    ];

    const errorActions = [
      <RaisedButton
        label="Ok"
        primary={true}
        onTouchTap={() => {this.setState({errorDialog: false})}}
        style={styles.dialogButton}
      />
    ];

    return (
      <div>
        {!this.state.isLoading &&
          <Dialog
            title="Booking Time"
            actions={actions}
            modal={false}
            open={this.state.dialogOpen}
            onRequestClose={this.closeDialog}
            bodyStyle={styles.center}
            titleStyle={styles.center}
            className="counteract-zoom"
          >
            <p>Please select when your car will be available to be washed:</p>
            <DropDownMenu
              value={this.state.startTime}
              style={styles.dropdown}
              onChange={this.handleStartTimeChange}
              autoWidth={false}
            >
              {this.state.startTimes.map((startTime) => {
                return (
                  <MenuItem key={startTime} value={startTime} primaryText={this.format(startTime)} />
                );
              })}
            </DropDownMenu>
          </Dialog>
        }

        <Dialog
          title="Warning"
          actions={errorActions}
          modal={true}
          open={this.state.errorDialog}
          bodyStyle={styles.center}
          titleStyle={styles.center}
          className="counteract-zoom"
        >
          <p>Please select the date before selecting the time</p>
        </Dialog>
        
        <TextField
            style={styles.textFieldStyle}
            hintStyle={styles.hintStyle}
            inputStyle={styles.inputStyle}
            hintText="Select Times"
            floatingLabelText={this.props.floatingLabelText}
            floatingLabelFixed={true}
            maxLength={128}
            value={this.props.details.time}
            onClick={() => this.setDialogOpen(true)}
            onChange={() => this.setDialogOpen(true)}
            onFocus={() => this.setDialogOpen(true)}
          />
        
      </div>
    );
  }
}

export default CustomTimePicker;



// WEBPACK FOOTER //
// ./src/app/components/elements/CustomTimePicker.js